export default class Nav {
    constructor($el) {
        this.$el = $el;
        this.$menu = this.$el.querySelector('.js-navMenu');
        this.$menuOverlay = this.$el.querySelector('.js-navMenuOverlay');
        this.$menuToggle = this.$el.querySelector('.js-navMenuToggle');

        this.previousScrollY = null;
        this.scrollDirection = null;

        this.initListeners();
    }

    get isOpen() {
        return this.$el.classList.contains('is-open');
    }

    open() {
        this.$el.classList.add('is-open');
        document.body.classList.add('is-navMenuOpen');
        this.$menuToggle?.setAttribute('aria-expanded', 'true');
    }

    close() {
        this.$el.classList.remove('is-open');
        document.body.classList.remove('is-navMenuOpen');
        this.$menuToggle?.setAttribute('aria-expanded', 'false');
    }

    toggle() {
        this.isOpen ? this.close() : this.open();
    }

    initListeners() {
        const onScroll = () => {
            if (this.previousScrollY !== null) {
                this.scrollDirection = window.scrollY > this.previousScrollY ? 'down' : 'up';
            }

            this.previousScrollY = window.scrollY;

            if (this.scrollDirection === 'down') {
                if (window.scrollY >= window.innerHeight * 0.1) {
                    // Scrolling down, hide menu bar
                    this.$el.classList.add('is-scrolled');
                }
            } else {
                // Scrolling back up, show menu bar
                this.$el.classList.remove('is-scrolled');
            }
        };

        this.$menuToggle?.addEventListener('click', () => {
            this.toggle();
        });

        this.$menuOverlay?.addEventListener('click', () => {
            this.close();
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.close();
                this.$menuToggle?.focus();
            }
        });

        window.addEventListener('scroll', onScroll);
        onScroll();
    }
}
